/**
 * Create store system dhcpSettings
 *
 * @since 2018-07-05
 * @author jongsung.Lee(devp010)
 */
import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

function getDhcpServerInfo () {
  return {
    normal_serv_use_enable: 0,
    normal_serv_rent_tm: 1440,
    normal_serv_auth: 0,
    dns_serv1: null,
    dns_serv2: null,
    wins_serv1: null,
    wins_serv2: null
  }
}
function getDhcpv6ServerInfo () {
  return {
    normal_serv_use_enable: 0,
    normal_serv_rent_tm: 1440,
    dns_serv1: null,
    dns_serv2: null
  }
}

function getApiUrlPath () {
  return { // axios api's urls
    serverConfig: `${smApiPrefix}/dhcp/server/config`,
    dhcpStatus: `${smApiPrefix}/dhcp/server/config/status`,
    dynamicArea: `${smApiPrefix}/dhcp/server/dynamic-areas`,
    macAddress: `${smApiPrefix}/dhcp/server/mac-addresses`,
    relayServerConfig: `${smApiPrefix}/dhcp/relay/config`,
    relayServers: `${smApiPrefix}/dhcp/relay/servers`,
    ipv6ServerConfig: `${smApiPrefix}/ipv6/dhcp/server/config`,
    ipv6DynamicArea: `${smApiPrefix}/ipv6/dhcp/server/dynamic-areas`,
    dhcpSettingsApply: `${smApiPrefix}/dhcp/server/apply`,
    dhcpSettingsCancel: `${smApiPrefix}/dhcp/server/cancel`,
    relaySettingsApply: `${smApiPrefix}/dhcp/relay/apply`,
    relaySettingsCancel: `${smApiPrefix}/dhcp/relay/cancel`,
    ipv6SettingsApply: `${smApiPrefix}/ipv6/dhcp/server/apply`,
    ipv6SettingsCancel: `${smApiPrefix}/ipv6/dhcp/server/cancel`
  }
}

export const state = () => ({
  apiUrlPath: getApiUrlPath(),
  // dialog common
  dialogMode: '',
  dialogTitleName: '',
  dialogFooterButton: [],
  dialogParam: [],
  selectedItem: {},
  // responseData
  resResultData: {
    reqType: '',
    resStatus: 404,
    resCode: 'nok',
    resMessage: ''
  },
  // dhcp server
  dhcpServerInfo: getDhcpServerInfo(),
  dhcpStatusList: [],
  dhcpServerInfoClone: getDhcpServerInfo(),
  // dynamic area info
  dhcpDynamicArea: {
    area_index: 0,
    start_area: null,
    end_area: null,
    net_addr: null,
    subnet_mask: null,
    default_gw: null
  },
  dhcpDynamicAreaList: [],
  // label: start_area ~ end_area, value: start_area^end_area
  dhcpAreaRangeList: [],
  // mac address info
  dhcpMacAddress: {
    mac_index: 0,
    area_index: '',
    host_name: '',
    mac_addr: null,
    ip_addr: null
  },
  dhcpMacAddressList: [],
  // dhcp relay config
  dhcpRelayConfig: {
    dhcp_relay_use: 0
  },
  dhcpRelayConfigClone: {
    dhcp_relay_use: 0
  },
  // dhcp relay server ip
  dhcpRelayServer: {
    serv_index: 0,
    enable: 0,
    serv_ip: null
  },
  dhcpRelayServerList: [],
  // dhcpv6
  dhcpv6ServerInfo: getDhcpv6ServerInfo(),
  dhcpv6ServerInfoClone: getDhcpv6ServerInfo(),
  dhcpv6DynamicArea: {
    area_index: 0,
    start_area: null,
    end_area: null,
    net_addr: null,
    subnet_mask: ''
  },
  dhcpv6DynamicAreaList: []
})

export const mutations = {
  // set dhcp dialog
  clearDhcpDialog (state) {
    state.dialogMode = ''
    state.dialogName = ''
    state.dialogTitleName = ''
    state.dialogFooterButton = null
    state.dialogParam = null
    state.selectedItem = null
    state.dhcpDynamicArea.area_index = 0
    state.dhcpDynamicArea.start_area = null
    state.dhcpDynamicArea.end_area = null
    state.dhcpDynamicArea.net_addr = null
    state.dhcpDynamicArea.subnet_mask = null
    state.dhcpDynamicArea.default_gw = null
  },
  setDhcpDialog (state, data) {
    if (data !== null && data !== undefined) {
      state.selectedItem = data
      state.dhcpDynamicArea.area_index = data.area_index
      state.dhcpDynamicArea.start_area = data.start_area
      state.dhcpDynamicArea.end_area = data.end_area
      state.dhcpDynamicArea.net_addr = data.net_addr
      state.dhcpDynamicArea.subnet_mask = data.subnet_mask
      state.dhcpDynamicArea.default_gw = data.default_gw
    }
  },
  clearDhcpMacDialog (state) {
    state.dialogMode = ''
    state.dialogName = ''
    state.dialogTitleName = ''
    state.dialogFooterButton = null
    state.dialogParam = null
    state.selectedItem = null
    state.dhcpMacAddress.mac_index = 0
    state.dhcpMacAddress.area_index = ''
    state.dhcpMacAddress.mac_addr = null
    state.dhcpMacAddress.host_name = ''
    state.dhcpMacAddress.ip_addr = null
  },
  setDhcpMacDialog (state, data) {
    if (data !== null && data !== undefined) {
      state.selectedItem = data
      state.dhcpMacAddress.mac_index = data.mac_index
      state.dhcpMacAddress.area_index = data.area_index
      state.dhcpMacAddress.mac_addr = data.mac_addr
      state.dhcpMacAddress.host_name = data.host_name
      state.dhcpMacAddress.ip_addr = data.ip_addr
    }
  },
  clearDhcpRelayServerDialog (state) {
    state.dialogMode = ''
    state.dialogName = ''
    state.dialogTitleName = ''
    state.dialogFooterButton = null
    state.dialogParam = null
    state.selectedItem = null
    state.dhcpRelayServer.serv_index = 0
    state.dhcpRelayServer.enable = 0
    state.dhcpRelayServer.serv_ip = null
  },
  setDhcpRelayServerDialog (state, data) {
    if (data !== null && data !== undefined) {
      state.selectedItem = data
      state.dhcpRelayServer.serv_index = data.serv_index
      state.dhcpRelayServer.enable = data.enable
      state.dhcpRelayServer.serv_ip = data.serv_ip
    }
  },
  clearDhcpIpv6DynamicDialog (state) {
    state.dialogMode = ''
    state.dialogName = ''
    state.dialogTitleName = ''
    state.dialogFooterButton = null
    state.dialogParam = null
    state.selectedItem = null
    state.dhcpv6DynamicArea.area_index = 0
    state.dhcpv6DynamicArea.start_area = null
    state.dhcpv6DynamicArea.end_area = null
    state.dhcpv6DynamicArea.net_addr = null
    state.dhcpv6DynamicArea.subnet_mask = ''
  },
  setDhcpIpv6DynamicDialog (state, data) {
    if (data !== null && data !== undefined) {
      state.selectedItem = data
      state.dhcpv6DynamicArea.area_index = data.area_index
      state.dhcpv6DynamicArea.start_area = data.start_area
      state.dhcpv6DynamicArea.end_area = data.end_area
      state.dhcpv6DynamicArea.net_addr = data.net_addr
      state.dhcpv6DynamicArea.subnet_mask = data.subnet_mask
    }
  },
  // set dhcp server config
  setDhcpServerConfig (state, data) {
    // dhcp info
    state.dhcpServerInfo = data
    // dhcp info clone
    state.dhcpServerInfoClone = _.cloneDeep(data)
  },
  // set dhcpStatusList
  setDhcpStatusList (state, data) {
    state.dhcpStatusList = []
    state.dhcpStatusList = data
  },
  // set dhcp dynamicArea
  resetDhcpDynamicArea (state) {
    state.dhcpDynamicArea = {
      area_index: 0,
      start_area: null,
      end_area: null,
      net_addr: null,
      subnet_mask: null,
      default_gw: null
    }
    state.dhcpDynamicAreaList = []
    state.dhcpAreaRangeList = []
  },
  // set dhcp dynamic area
  setDhcpDynamicArea (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpDynamicAreaList = data
    }
  },
  setDhcpAreaRange (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpAreaRangeList = data
    }
  },
  addDhcpAreaRange (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpAreaRangeList.push(data)
    }
  },
  addDhcpDynamicArea (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpDynamicAreaList.push(data)
    }
  },
  edtDhcpDynamicArea (state, item) {
    const findRslt = _.find(state.dhcpDynamicAreaList, {area_index: item.area_index})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.dhcpDynamicAreaList.splice(findRslt.itemIndex, 1, item)
    }
  },
  delDhcpDynamicArea (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.dhcpDynamicAreaList.splice(item.itemIndex, 1)
      }
    }
  },
  resetDhcpMacAddr (state) {
    state.dhcpMacAddress = {
      mac_index: 0,
      area_index: '',
      host_name: '',
      mac_addr: null,
      ip_addr: null
    }
    state.dhcpMacAddressList = []
  },
  // set dhcp mac address
  setDhcpMacAddr (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpMacAddressList = data
    }
  },
  addDhcpMacAddr (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpMacAddressList.push(data)
    }
  },
  edtDhcpMacAddr (state, item) {
    const findRslt = _.find(state.dhcpMacAddressList, {mac_index: item.mac_index})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.dhcpMacAddressList.splice(findRslt.itemIndex, 1, item)
    }
  },
  delDhcpMacAddr (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.dhcpMacAddressList.splice(item.itemIndex, 1)
      }
    }
  },
  // set dhcp relay server config
  setDhcpRelayConfig (state, data) {
    state.dhcpRelayConfig = data
    // clone
    state.dhcpRelayConfigClone = _.cloneDeep(data)
  },
  // set dhcp dynamicArea
  resetDhcpRelayServer (state) {
    state.dhcpRelayServer = {
      serv_index: 0,
      enable: 0,
      serv_ip: null
    }
    state.dhcpRelayServerList = []
  },
  setDhcpRelayServer (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpRelayServerList = data
    }
  },
  addDhcpRelayServer (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpRelayServerList.push(data)
    }
  },
  edtDhcpRelayServer (state, item) {
    const findRslt = _.find(state.dhcpRelayServerList, {serv_index: item.serv_index})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.dhcpRelayServerList.splice(findRslt.itemIndex, 1, item)
    }
  },
  delDhcpRelayServer (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.dhcpRelayServerList.splice(item.itemIndex, 1)
      }
    }
  },

  // set dhcpIPv6 server config
  setDhcpIpv6ServerConfig (state, data) {
    state.dhcpv6ServerInfo = data
    // clone
    state.dhcpv6ServerInfoClone = _.cloneDeep(data)
  },
  // set dhcpIPv6 dynamicArea
  resetDhcpIpv6DynamicArea (state) {
    state.dhcpv6DynamicArea = {
      area_index: 0,
      start_area: null,
      end_area: null,
      net_addr: null,
      subnet_mask: ''
    }
    state.dhcpv6DynamicAreaList = []
  },
  // set dhcp dynamic area
  setDhcpIpv6DynamicArea (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpv6DynamicAreaList = data
    }
  },
  addDhcpIpv6DynamicArea (state, data) {
    if (data !== null && data !== undefined) {
      state.dhcpv6DynamicAreaList.push(data)
    }
  },
  edtDhcpIpv6DynamicArea (state, item) {
    if (item !== null && item !== undefined) {
      const findRslt = _.find(state.dhcpv6DynamicAreaList, {area_index: item.area_index})
      if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
        state.dhcpv6DynamicAreaList.splice(findRslt.itemIndex, 1, item)
      }
    }
  },
  delDhcpIpv6DynamicArea (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.dhcpv6DynamicAreaList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // dhcp sever config
  async getDhcpServerConfig ({commit, state}, loadingOpt) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['serverConfig'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setDhcpServerConfig', result)
      return true
    } else {
      return false
    }
  },
  // dhcp dynamic area
  async getDhcpDynamicArea ({commit, state}, loadingOpt) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['dynamicArea'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('resetDhcpDynamicArea')
      // REAL CODE
      commit('setDhcpDynamicArea', result)
      // set dynamic area for macAddress
      const rangeData = []
      for (const areaData of result) {
        rangeData.push({
          label: areaData.start_area + '^' + areaData.end_area,
          value: areaData.area_index
        })
      }
      commit('setDhcpAreaRange', rangeData)
      return true
    } else {
      return false
    }
  },
  async getDhcpStatusList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['dhcpStatus'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setDhcpStatusList', result)
      return true
    } else {
      return false
    }
  },
  async addDhcpDynamicArea ({commit, state}) {
    const addParam = _.cloneDeep(state.dhcpDynamicArea)
    delete addParam.area_index
    const {code, result} = await this.$axios.$post(state.apiUrlPath['dynamicArea'], addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addDhcpDynamicArea', result)
      // set range-data of dynamic-area for macAddress
      const rangeData = {
        label: result.start_area + '^' + result.end_area,
        value: result.area_index
      }
      commit('addDhcpAreaRange', rangeData)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async edtDhcpDynamicArea ({commit, state}) {
    const data = await this.$axios.$put(`${state.apiUrlPath['dynamicArea']}/${state.dhcpDynamicArea.area_index}`, state.dhcpDynamicArea)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('edtDhcpDynamicArea', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delDhcpDynamicArea ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({area_index: idx.area_index, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['dynamicArea']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].area_index}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delDhcpDynamicArea', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // dhcp mac address
  async getDhcpMacAddress ({commit, state}, loadingOpt) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['macAddress'], loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('resetDhcpMacAddr')
      commit('setDhcpMacAddr', result)
      return true
    } else {
      return false
    }
  },
  async addDhcpMacAddress ({commit, state}) {
    const addParam = _.cloneDeep(state.dhcpMacAddress)
    delete addParam.mac_index
    const data = await this.$axios.$post(state.apiUrlPath['macAddress'], addParam)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('addDhcpMacAddr', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async edtDhcpMacAddress ({commit, state}) {
    const data = await this.$axios.$put(`${state.apiUrlPath['macAddress']}/${state.dhcpMacAddress.mac_index}`, state.dhcpMacAddress)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('edtDhcpMacAddr', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delDhcpMacAddr ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({mac_index: idx.mac_index, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['macAddress']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].mac_index}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delDhcpMacAddr', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // dhcp relay sever config
  async getDhcpRelayServerConfig ({commit, state}, loadingOpt) {
    const rslt = await this.$axios.$get(state.apiUrlPath['relayServerConfig'], loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setDhcpRelayConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // get relay server list
  async getDhcpRelayServer ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrlPath['relayServers'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('resetDhcpRelayServer')
      commit('setDhcpRelayServer', result)
      return true
    } else {
      return false
    }
  },
  async addDhcpRelayServer ({commit, state}) {
    const addParam = _.cloneDeep(state.dhcpRelayServer)
    delete addParam.serv_index
    const data = await this.$axios.$post(state.apiUrlPath['relayServers'], addParam)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('addDhcpRelayServer', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async edtDhcpRelayServer ({commit, state}) {
    const data = await this.$axios.$put(`${state.apiUrlPath['relayServers']}/${state.dhcpRelayServer.serv_index}`, state.dhcpRelayServer)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('edtDhcpRelayServer', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delDhcpRelayServer ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({serv_index: idx.serv_index, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['relayServers']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].serv_index}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delDhcpRelayServer', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // dhcpIPv6 server config
  async getDhcpIPv6ServerConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ipv6ServerConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setDhcpIpv6ServerConfig', result)
      return true
    } else {
      return false
    }
  },
  // dhcpIPv6 get dynamic area
  async getDhcpIPv6DynamicArea ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ipv6DynamicArea']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('resetDhcpIpv6DynamicArea')
      // REAL CODE
      commit('setDhcpIpv6DynamicArea', result)
      return true
    } else {
      return false
    }
  },
  // dhcpIPv6 add dynamic area
  async addDhcpIPv6DynamicArea ({commit, state}, isContinue) {
    const addParam = _.cloneDeep(state.dhcpv6DynamicArea)
    addParam.subnet_mask = Number(addParam.subnet_mask)
    delete addParam.id
    const data = await this.$axios.$post(state.apiUrlPath['ipv6DynamicArea'], addParam)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('addDhcpIpv6DynamicArea', data.result)
      if (!isContinue) {
        commit('clearDhcpIpv6DynamicDialog')
      }
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // dhcpIPv6 edit dynamic area
  async edtDhcpIPv6DynamicArea ({commit, state}) {
    const putParam = _.cloneDeep(state.dhcpv6DynamicArea)
    delete putParam.area_index
    putParam.subnet_mask = Number(putParam.subnet_mask)
    const data = await this.$axios.$put(`${state.apiUrlPath['ipv6DynamicArea']}/${state.dhcpv6DynamicArea.area_index}`, putParam)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      commit('edtDhcpIpv6DynamicArea', data.result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // dhcpIPv6 delete dynamic area
  async delDhcpIPv6DynamicArea ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({area_index: idx.area_index, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ipv6DynamicArea']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].area_index}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delDhcpIpv6DynamicArea', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // ## apply & cancel ##
  // dhcp server apply
  async setDhcpServerApply ({commit, state}, loadingOpt) {
    // step 1. set server config
    const apiUrl = state.apiUrlPath['serverConfig']
    const putRslt = await this.$axios.$put(apiUrl, state.dhcpServerInfo, {loadingHide: false, successAlert: false})
    if (putRslt.code !== undefined && (putRslt.code).toLowerCase() === 'ok') {
      commit('setDhcpServerConfig', putRslt.result)
      // step 2. apply config
      const rslt = await this.$axios.$put(state.apiUrlPath['dhcpSettingsApply'], null, loadingOpt)
      if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
        // commit common isChanage
        this.dispatch(`common/common/setIsChanged`, false)
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  async setDhcpServerCancel ({commit, state, dispatch}, loadingOpt) {
    // step 1. set cancel
    const rslt = await this.$axios.$put(state.apiUrlPath['dhcpSettingsCancel'], null, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      // step 2. get dhcp serverConfig
      await dispatch('getDhcpServerConfig')
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  // dhcp relayServer apply
  async setDhcpRelayApply ({commit, state}, loadingOpt) {
    // step 1. set relay config
    const apiUrl = state.apiUrlPath['relayServerConfig']
    const rslt = await this.$axios.$put(apiUrl, state.dhcpRelayConfig, {loadingHide: false, successAlert: false})
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setDhcpRelayConfig', rslt.result)
      // step 2. apply relay
      const data = await this.$axios.$put(state.apiUrlPath['relaySettingsApply'], null, loadingOpt)
      if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
        // commit common isChanage
        this.dispatch(`common/common/setIsChanged`, false)
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  async setDhcpRelayCancel ({commit, state, dispatch}, loadingOpt) {
    // step 1. set cancel
    const rslt = await this.$axios.$put(state.apiUrlPath['relaySettingsCancel'], null, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      // step 2. get dhcp serverConfig
      await dispatch('getDhcpRelayServer')
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  // dhcp ipv6 apply
  async setIpv6Apply ({commit, state}) {
    const apiUrl = state.apiUrlPath['ipv6ServerConfig']
    // step 1. set ipv6 server config
    const putRslt = await this.$axios.$put(apiUrl, state.dhcpv6ServerInfo, {loadingHide: false, successAlert: false})
    if (putRslt.code !== undefined && (putRslt.code).toLowerCase() === 'ok') {
      commit('setDhcpIpv6ServerConfig', putRslt.result)
      // step 2. apply dhcp ipv6
      const data = await this.$axios.$put(state.apiUrlPath['ipv6SettingsApply'], null, {applyMsg: true})
      if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
        // commit common isChanage
        this.dispatch(`common/common/setIsChanged`, false)
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  async setIpv6Cancel ({commit, state, dispatch}) {
    // step 1. set cancel
    const data = await this.$axios.$put(state.apiUrlPath['ipv6SettingsCancel'], null, {cancelMsg: true})
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // step 2. get ipv6 serverConfig
      await dispatch('getDhcpIPv6ServerConfig')
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
}

export const getters = {
  // dhcp server config compare
  compareDhcpConfigData (state) {
    return compareObject(state.dhcpServerInfo, state.dhcpServerInfoClone)
  },
  // dhcp relay server config
  compareDhcpRelayConfigData (state) {
    return compareObject(state.dhcpRelayConfig, state.dhcpRelayConfigClone)
  },
  // dhcp v6 config
  compareDhcpv6ConfigData (state) {
    return compareObject(state.dhcpv6ServerInfo, state.dhcpv6ServerInfoClone)
  }
}

export const strict = false
